export class Token {
    constructor(token) {
        this.accessToken = token.accessToken;
        this.refreshToken = token.refreshToken;
        this.accessTokenValidUntil = token.accessTokenValidUntil;
    }
    encode(context) {
        return {
            "access_token": this.accessToken,
            "token_type": "bearer",
            "expires_in": (this.accessTokenValidUntil.getTime() - new Date().getTime()) / 1000,
            "refresh_token": this.refreshToken,
        };
    }
    static decode(data) {
        return new Token({
            accessToken: data.field("access_token").string,
            refreshToken: data.field("refresh_token").string,
            accessTokenValidUntil: new Date(Date.now() + data.field("expires_in").number * 1000 - 30 * 1000),
        });
    }
}
//# sourceMappingURL=Token.js.map